import React, { useContext, useState } from "react";
import { Button, Input } from "../components/Form";
import { BiLogInCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { confirmLogin, login } from "../api/auth-scripts";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import UserContext from "../context/UserContext";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../components/LanguageSelector";
import PublicPageLayout from "../components/Layouts/PublicPageLayout";

function OtpPage() {
  const [otp, setOtp] = useState("");
  const { setUser } = useContext(UserContext);
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleConfirm = async (e) => {
    e.preventDefault();
    await confirmLogin(otp, toast, navigate, setUser, t);
  };

  return (
    <PublicPageLayout>
      <div className="absolute top-1 right-1 md:right-5 z-10">
        {/* <LanguageSelector /> */}
      </div>
      <div className="w-full h-screen flex-colo px-4">
        <form
          className="w-full max-w-md p-6 sm:p-8 rounded-2xl bg-white flex-colo shadow-md"
          onSubmit={handleConfirm}>
          <img
            src="/images/iterum-logo-writting.png"
            alt="logo"
            className="w-36 sm:w-48 h-12 sm:h-16 object-contain"
          />
          <div className="flex flex-col gap-4 w-full mb-6">
            <Input
              label={"OTP"}
              type="text"
              color={true}
              placeholder={"XXXXXX"}
              autocomplete="username"
              onChange={(event) => setOtp(event.target.value)}
            />
          </div>
          <Button label={"Confirm"} Icon={BiLogInCircle} />

          {/* TODO: Translate */}
          {/* <div className="mt-4 text-center text-sm text-gray-500">
            {t("signup.dont")}{" "}
            <a
              href="/sign-up"
              className="text-subMain hover:text-subMain-dark font-medium transition">
              {t("signup.create")}
            </a>
          </div> */}
        </form>
      </div>
    </PublicPageLayout>
  );
}

export default OtpPage;
